
import React, { useState, useEffect } from "react";
import {useParams} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DownloadSpeciesData from "../services/downloadSpeciesTable.jsx";
import DownloadCountryPoliciesResponses from "../services/downloadCountryPoliciesResponsesTable.jsx"
import '../styles/pages.css'; 
import { RotatingLines} from 'react-loader-spinner'
import UtilsLocalizedString from "../services/utilsLocalizedString.jsx";
import axios from 'axios';
import * as XLSX from 'xlsx';

function OneCountryPage() {
    let { id } = useParams();
    const { t } = useTranslation();
    const[countryRepLoaded, setCountryRep] = useState(false);
    const [territoryFromServer, setTerritoryFromServer] = useState("");
    const [countryLevelData, setCountryLevelData] = useState("");
    const [speciesData, setSpeciesData] = useState("");
    const [noData, setNoData] = useState(false);
      const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
     const [excelDataSheet, setExcelDataSheet]= useState("");
 
  
    
    useEffect(() => {
      const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[2];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };


      const fetchData = async () => {
        if(countryRepLoaded === false) {
        
          fetch(`${process.env.REACT_APP_BACKEND_API}/accounts/territories/${id.split("-")[1]}/`, {
            method: "GET",
             headers: {
             "accept": "application/json",
             "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
             },
   })
     .then((response) => response.json())
     .then((data) => {
      setTerritoryFromServer(data);
      setCountryRep(true);
    
     })
     .catch((error) => console.log(error));
     fetch(`${process.env.REACT_APP_BACKEND_API}/submission/package/by_territory/${id.split("-")[1]}/`, {
      method: "GET",
       headers: {
       "accept": "application/json",
          "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
       },
  })
  .then((response) => response.ok ? response.json() : setNoData(true))
  .then((data) => {

  if( data !== undefined && data.submission_species !== undefined) {
  const refactoredData = data.submission_species.map(spec => ({
        species: spec.species.name,
        national_distribution_available : spec.species_answers.filter(ans => ans.question === 133).length > 0 ? spec.species_answers.filter(ans => ans.question === 133)[0].value === "0"  ? 1 : 0 : 0,
        non_molecular_characterization: spec.species_answers.filter(ans => ans.question === 137).length > 0 ? spec.species_answers.filter(ans => ans.question === 137)[0].value === "0"  ? 1 : 0 : 0,
        molecular_characterization: spec.species_answers.filter(ans => ans.question === 140).length > 0 ? spec.species_answers.filter(ans => ans.question === 140)[0].value === "0"  ? 1 : 0 : 0,
        in_situ_programme: spec.species_answers.filter(ans => ans.quesion === 145).length > 0 ? spec.species_answers.filter(ans => ans.question === 145)[0].value === "0"  ? 1 : 0 : 0,
        number_situ_units: spec.species_answers.filter(ans => ans.question === 148).length > 0 ? spec.species_answers.filter(ans => ans.question === 148)[0].value : "",
        area_in_situ: spec.species_answers.filter(ans => ans.question === 151).length > 0 ? spec.species_answers.filter(ans => ans.question === 151)[0].value : "",
        ex_situ_programme: spec.species_answers.filter(ans => ans.question === 155).length > 0 ? spec.species_answers.filter(ans => ans.question === 155)[0].value === "0"  ? 1 : 0 : 0,
        number_ex_situ: spec.species_answers.filter(ans => ans.question === 158).length > 0 ? spec.species_answers.filter(ans => ans.question === 158)[0].value : "",
        area_ex_situ: spec.species_answers.filter(ans => ans.question === 161).length > 0 ? spec.species_answers.filter(ans => ans.question === 161)[0].value : "",
        number_ex_situ_accessions: spec.species_answers.filter(ans => ans.question === 164).length > 0 ? spec.species_answers.filter(ans => ans.question === 164)[0].value : "",
        national_tree_seed_prog: spec.species_answers.filter(ans => ans.question === 169).length > 0 ? spec.species_answers.filter(ans => ans.question === 169)[0].value === "0"  ? 1 : 0 : 0,
        tree_breeding_prog: spec.species_answers.filter(ans => ans.question === 172).length > 0 ? spec.species_answers.filter(ans => ans.question === 172)[0].value === "0"  ? 1 : 0 : 0,
        area_seed_stands: spec.species_answers.filter(ans => ans.question === 176).length > 0 ? spec.species_answers.filter(ans => ans.question === 176)[0].value : "",
        number_seed_stands: spec.species_answers.filter(ans => ans.question === 257).length > 0 ? spec.species_answers.filter(ans => ans.question === 257)[0].value : "",
        area_seed_orchards: spec.species_answers.filter(ans => ans.question === 179).length > 0 ? spec.species_answers.filter(ans => ans.question === 179)[0].value : "",
        number_seed_orchards: spec.species_answers.filter(ans => ans.question === 259).length > 0 ? spec.species_answers.filter(ans => ans.question === 259)[0].value : "",
        planting_stock_year: spec.species_answers.filter(ans => ans.question === 182).length > 0 ? spec.species_answers.filter(ans => ans.question === 182)[0].value : "",
        state_tree_breeding_prog: spec.species_answers.filter(ans => ans.question === 186).length > 0 ? spec.species_answers.filter(ans => ans.question === 186)[0].value : "",
      })
    );
    setCountryLevelData(data.answers)

    const nextList = [...refactoredData];
    nextList.sort((a, b) => {
      const nameA = a.species.toUpperCase(); // ignore upper and lowercase
      const nameB = b.species.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      return 0;
    });
    setSpeciesData(nextList);
  } 

  
  })
  .catch((error) => console.log(error));
        }
      };
      handleFetchFromUrl();
      fetchData();
    }, [ territoryFromServer, id, excelDataSheet, countryRepLoaded]);
       return (
  
      
      <React.Fragment>
         <br></br> 
          <div className="App">
     <Container>
      <h3 className="target-legend-element">{UtilsLocalizedString(window.location.pathname.split("/")[2], territoryFromServer)}</h3> 
     <Row>

      <Col xs={12} sm={6} lg={6}>
     
      {
      // state.territoryid.length > 0 && 
      territoryFromServer !== undefined   ?
     
     <div key={territoryFromServer.id}>
      <br></br>
      <h5 className="country-title">{t('national_focal_point')}</h5>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_name')}: </span><span className="country-details">{territoryFromServer.focal_point_name}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_email')}: </span><span className="country-details">{territoryFromServer.focal_point_email}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_position')}: </span><span className="country-details">{territoryFromServer.focal_point_position}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_organization')}: </span><span className="country-details">{territoryFromServer.focal_point_organization}</span></p>
      {territoryFromServer.alternate_name !== null ?
      <div>
      <br></br>
      <h5 className="country-title">{t('alternate_title')}</h5>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_name')}: </span><span className="country-details">{territoryFromServer.alternate_name}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_email')}: </span><span className="country-details">{territoryFromServer.alternate_email}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_position')}: </span><span className="country-details">{territoryFromServer.alternate_position}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_organization')}: </span><span className="country-details">{territoryFromServer.alternate_organization}</span></p></div> : <div></div>}
 {territoryFromServer.alternate_name_2 !== null && territoryFromServer.alternate_name_2 !== "" ?
      <div>
      <br></br>
      <h5 className="country-title">{t('second_alternate')}</h5>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_name')}: </span><span className="country-details">{territoryFromServer.alternate_name_2}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_email')}: </span><span className="country-details">{territoryFromServer.alternate_email_2}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_position')}: </span><span className="country-details">{territoryFromServer.alternate_position_2}</span></p>
      <p style={{marginBottom: "0.3rem"}}><span>{t('title_organization')}: </span><span className="country-details">{territoryFromServer.alternate_organization_2}</span></p></div> : <div></div>}
     </div> :   <div key="no-contacts"><br></br><p>{t('no_contacts')}</p></div>}





      </Col>
      <Col  xs={12} sm={6} lg={6}>
     
      { excelDataSheet !== "" 
        && excelDataSheet.filter((elem) => elem[3] == id.split("-")[1]).length > 0 ?
        excelDataSheet.filter((elem) => elem[3] == id.split("-")[1]).map((selected, index) => 
     <div key={"object_report" + index}>
       <hr></hr>
       {index === 0 &&
      <h4 key={"title" + selected[2]+index}>{t('narrative_country_report')}</h4>}
     
      <div className="d-grid gap-2" key={selected[2]+index}>
       
      <Button style={{backgroundColor: "#116AAB",  width: "300px" , border:"1px solid #116AAB"}} 
      key={"buttonreport" + index}>
      <a style={{textDecoration: "none", color:"white"}} href={selected[1]} target="_blank" rel="noopener noreferrer">
      <span style={{marginLeft: "0.5rem", marginRight: "0.5rem",  
      verticalAlign: "middle"}}>{selected[0]}</span><img style={{verticalAlign: "middle"}} 
      src={process.env.PUBLIC_URL + `/img/box-arrow-up-right.svg`} 
      alt="arrow up right open" />
      </a>
      </Button>
      </div></div>)
      : <div></div>} 

      <br></br>
      <br></br>
       <hr></hr>
  
      <h4>{t('data_summary')}</h4>
      <div className="d-grid gap-2" key="download_policies_button">
    
        
        {countryLevelData !== undefined && countryLevelData.length > 0 ?
         <DownloadCountryPoliciesResponses  type="country" 
         data={countryLevelData} country={territoryFromServer.name} page="countryPage"/> 
      : 
      countryLevelData !== undefined && countryLevelData.length === 0  && !noData ?
       <div key="rotating-lines" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop:"3rem"
      }}><RotatingLines
      visible={true}
      height="96"
      width="96"
      strokeColor="#116AAB"
      color="#116AAB"
      strokeWidth="5"
      animationDuration="0.75"
      ariaLabel="rotating-lines-loading"
      wrapperStyle={{}}
      wrapperClass=""
  /><h6 style={{ marginLeft: "10px", marginRight: "10px"}}>{t('loading')}...</h6></div> :
      
      
       <div><p>{t('country_data_not_available')}</p></div>}
      </div> 
      <br></br>
      {speciesData !== undefined && speciesData.length > 0 ?
      <div className="d-grid gap-2" key="download_species_button">
         <DownloadSpeciesData type="country" questionnairePart="species" data={speciesData} country={territoryFromServer.name} page="countryPage"/>
     
      </div> : <div></div>}
      

      </Col>
     </Row>

     </Container>
   
     
   
    
<br/>

</div>
      </React.Fragment>
    );
  }

  export default OneCountryPage;